// Layout values increases directly proportionally above the following screen width
export const baseScreenWidth: number = 1920;

// Base height of Google map
export const baseMapHeight: number = 435;